/**
 * @desc 启动沃尔玛调拨入库定时器
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/test/testTimeTask`, {
      method: "POST",

      ...options,
    }),
  );
}
